import { feedbackApi } from '~/utils/api';

// Feedback validator code is at:
// https://github.com/robocorp/robocorp-feedback-backend/blob/master/sls-api/src/classes/Validator.ts

export const sendFeedback = async (npsScore: number | undefined, email: string, message: string) =>
  feedbackApi.post<void>('', {
    npsScore,
    email,
    content: message,
    source: 'Robocorp Cloud feedback form',
  });

export const sendServiceDeskTicket = async (
  organizationId: string,
  email: string,
  subject: string,
  content: string,
  sla: string,
) =>
  feedbackApi.post<void>('', {
    organizationId,
    email,
    subject,
    content,
    sla,
  });
